import createTask from './createTask/reducers'

export default {
  createTask,
}
